module.exports = __webpack_public_path__ + "img/195.0c272ca2.jpg";